import { makeAutoObservable } from 'mobx'
import * as API from 'service/api/CreditManageApi'
import table from '../common/table'
import { IInit } from 'models/Global.model'
import { IRechargeParam } from 'models/CreditManage.model'

class CreditManageStore {
  constructor() {
    makeAutoObservable(this)
  }

  creditTable = new table(API.GET_ACCOUNT_TRANSACTION_PAGE_LIST)

  init = (data: IInit) => {
    const {
      param = {},
      pageSize = 10,
      pageNo = 1,
      isPageNum = true,
      isResetParam = false
    } = data

    this.creditTable.init(param, isPageNum, isResetParam)
    this.creditTable.getList(pageNo, pageSize)
  }

  customerTable = new table(API.GET_CUSTOMER_TRANSACTION_PAGE_LIST)

  initCustomer = (data: IInit) => {
    const {
      param = {},
      pageSize = 10,
      pageNo = 1,
      isPageNum = true,
      isResetParam = false
    } = data

    this.customerTable.init(param, isPageNum, isResetParam)
    this.customerTable.getList(pageNo, pageSize)
  }

  recharge = async (data: IRechargeParam) => {
    return await API.RECHARGE(data)
  }

  getAccountBalance = async (pdtStoreId: string) => {
    return await API.GET_ACCOUNT_BALANCE(pdtStoreId)
  }

  getCustomerBalance = async (pdtStoreId: string) => {
    return await API.GET_CUSTOMER_BALANCE(pdtStoreId)
  }
}

export default new CreditManageStore()
